import {
  Box,
  Text,
  Input,
  Button,
  Checkbox,
  InputRightElement,
  InputGroup,
  FormControl,
  Heading,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { getEndpoint, getOptions } from "../constants/api";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

export default function Home() {
  const [password, setPassword] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadOverlay, setLoadOverlay] = useState(false);
  const [loginRes, setLoginRes] = useState({});
  const [accept, setAccept] = useState(false);
  const [force, setForce] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => setShow(!show);

  // ---------------
  // MAIN LOGIN
  // ---------------
  const onLogin = async () => {
    if (!password) {
      alert("Put in your password first");
      return;
    }
    if (!accept) {
      alert("Accept terms and conditions");
      return;
    }

    setIsLoading(true);
    setLoadOverlay(true);

    const packet = {
      ip: uuidv4(),
      password: password,
      device: deviceName,
    };

    const options = getOptions(packet);
    const endpoint = getEndpoint("login");

    try {
      const res = await fetch(endpoint, options);
      const data = await res.json();
      setLoginRes(data);
    } catch (error) {
      alert(error);
    } finally {
      setIsLoading(false);
      setLoadOverlay(false);
    }
  };

  // ---------------
  // FORCE LOGIN
  // ---------------
  const forceLogin = async () => {
    const packet = {
      ip: uuidv4(),
      password: password,
      device: deviceName,
    };

    const options = getOptions(packet);
    const endpoint = getEndpoint("forcelogin");

    try {
      const res = await fetch(endpoint, options);
      const data = await res.json();

      // If force is successful, store centerName in session
      if (data.status === "valid") {
        sessionStorage.setItem("pack", JSON.stringify({
          ip: packet.ip,
          password: packet.password,
          device: packet.device,
          centerName: data.centerName
        }));
        navigate("/live");
      } else {
        alert("Force login failed.");
      }
    } catch (error) {
      alert(error);
    }
  };

  // ---------------
  // AFTER LOGIN: VALIDATE
  // ---------------
  const loginValidation = () => {
    if (loginRes.status === "valid") {
      // Automatic forceLogin
      forceLogin();
    } else if (loginRes.status === "already in") {
      setForce(true);
      alert(
        `Status: already logged in\n` +
        `Device: ${loginRes.device}\n` +
        `If IP has changed, force login.`
      );
    } else if (loginRes.status === "Invalid Password") {
      alert("Wrong Password. Make sure no spaces.");
    }
  };

  // On "already in" or "valid", we haven't yet stored centerName in session
  // Because "already in" or "valid" triggers forceLogin(), the center name
  // will get stored once the forceLogin call returns.  

  useEffect(() => {
    if (!isLoading) {
      loginValidation();
    }
  }, [isLoading]);

  // ---------------
  // RENDER
  // ---------------
  let loginButton = force ? (
    <Button colorScheme="red" margin="3px 0" onClick={forceLogin}>
      Force
    </Button>
  ) : (
    <Button colorScheme="red" margin="3px 0" onClick={onLogin}>
      Submit
    </Button>
  );

  let loading;
  if (loadOverlay) {
    loading = (
      <Box
        position="fixed"
        zIndex="999"
        left="0"
        top="0"
        width="100%"
        height="100%"
        overflow="auto"
        backgroundColor="rgba(0,0,0,0.4)"
      >
        <Text
          textAlign="center"
          verticalAlign="middle"
          lineHeight="100vh"
          fontWeight="bold"
        >
          Loading ...
        </Text>
      </Box>
    );
  }

  return (
    <Box textAlign="center" color="white">
      {loading}
      <Box
        padding="10px"
        backgroundColor="#424242"
        width="70%"
        margin="40px auto"
        borderRadius="md"
        textAlign="left"
      >
        <Heading
          textTransform="uppercase"
          as="h2"
          size="xl"
          color="white"
          textAlign="center"
          marginBottom="20px"
        >
          Viewing Center Login
        </Heading>
        <FormControl marginBottom="10px">
          <InputGroup size="md">
            <Input
              pr="4.5rem"
              type={show ? "text" : "password"}
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
              readOnly={force}
            />
            <InputRightElement width="4.5rem">
              <Button h="1.75rem" size="sm" onClick={handleClick} color="black">
                {show ? "Hide" : "Show"}
              </Button>
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <Box padding="10px 0">
          <Text color="white">Device Name</Text>
          <Input
            type="text"
            placeholder="Remember Device Name"
            margin="5px 0"
            readOnly={force}
            onChange={(e) => setDeviceName(e.target.value)}
          />
        </Box>
        <Box color="white" marginBottom="10px">
          <Checkbox
            padding="5px"
            checked={accept}
            onChange={(e) => setAccept(e.target.checked)}
          />
          <Text display="inline" marginLeft="10px">
            By logging in, you confirm that you accept to not share your login
            details with a third party and that the ministry retains full and
            exclusive copyright ownership.
          </Text>
        </Box>
        {loginButton}
      </Box>
    </Box>
  );
}
